export const SET_API_UPDATE_RESTAURANT = 'SET_API_UPDATE_RESTAURANT'
export const SET_API_UPDATE_NEW_RESTAURANT = 'SET_API_UPDATE_NEW_RESTAURANT'
export const SET_ALL_API_RESTAURANTS = 'SET_ALL_API_RESTAURANTS'
export const SET_API_RESTAURANTS_IS_LOADING = 'SET_API_RESTAURANTS_IS_LOADING'
